module.exports = __webpack_public_path__ + "static/media/Basal_4521.d263d09c.jpg";